/* ========================================== Start Of Header Fixed Javascript ========================================== */
jQuery(window).scroll(function () {
    if (jQuery(window).scrollTop() >= 100) {
        jQuery('#header').addClass('fixed-header');

    } else {
        jQuery('#header').removeClass('fixed-header');

    }
});
/* ========================================== End Of Header Fixed Javascript ========================================== */


/* ========================================== Start Of Menu Active Class ========================================== */
jQuery("ul li a").filter(function(){
  return this.href == location.href.replace(/#.*/, "");
}).closest("li").addClass("active");
/* ========================================== End Of Menu Active Class ========================================== */


/* ========================================== Start Of Slick Slider Javascript  ========================================== */

jQuery('.hero-slider').slick({
    infinite: true,
    arrows: false,
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [{
            breakpoint: 767,
            settings: {
                arrows: false,
                dots: true,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});


jQuery('.hero-slider-new').slick({
    infinite: true,
    arrows: true,
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    prevArrow: '<button class="slide-arrow prev-arrow">PREV</button>',
    nextArrow: '<button class="slide-arrow next-arrow">NEXT</button>',
    responsive: [{
            breakpoint: 992,
            settings: {
                arrows: false,
                dots: true,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
                 {
            breakpoint: 767,
            settings: {
                arrows: false,
                dots: true,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});


jQuery('.brands-slider').slick({
    infinite: true,
    arrows: false,
    dots: false,
    slidesToShow: 5,
    slidesToScroll: 5,
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [{
            breakpoint: 767,
            settings: {
                arrows: false,
                dots: false,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});

jQuery('.brands-slider-new').slick({
    infinite: true,
    arrows: false,
    dots: false,
    rows: 1,  
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [{
            breakpoint: 767,
            settings: {
                arrows: false,
                dots: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                rows: 1,
            }
        }
    ]
});


jQuery('.testimonials-slider').slick({
    infinite: true,
    arrows: false,
    dots: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
    responsive: [{
            breakpoint: 992,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,

            }
        },
        {
            breakpoint: 767,
            settings: {
                arrows: false,
                dots: true,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});

jQuery('.product-slider').slick({
    infinite: true,
    arrows: true,
    dots: false,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [{
            breakpoint: 992,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,

            }
        },
        {
            breakpoint: 767,
            settings: {
                arrows: false,
                dots: true,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});

jQuery('.mobile-slider').slick({
    infinite: true,
    arrows: false,
    dots: true,
    slidesToShow: 2,
    mobileFirst: true, 
    responsive: [
       {
          breakpoint: 767,
          settings: "unslick"
       }
    ]
});

/* ========================================== End Of Slick Slider Javascript ========================================== */

/* ========================================== Start Of Menu Target Blank Javascript  ========================================== */
jQuery('.Training a').attr('target', '_blank');
jQuery('.Corporate a').attr('target', '_blank');
/* ========================================== End Of Menu Target Blank Javascript ========================================== */

/* ========================================== Start Of Menu Categories Text Replace Javascript  ========================================== */
jQuery('.CATEGORIES a span').text('Products');
jQuery('.CATEGORIES .navigation-mobile-item-link a span:first').text('Products');
/* ========================================== End Of Menu Categories Text Replace Javascript ========================================== */

/* ========================================== Start Of Match Height Javascript  ========================================== */
function MatchHeight() {
  jQuery('.match').matchHeight({});
  jQuery('.same-height').matchHeight({});  
  //jQuery('.pr-tital-bg').matchHeight({});   
}
jQuery(document).ready(function(){
  MatchHeight();
    setTimeout(function() {
        $('.recently-viewed-products .same-height').matchHeight();    
    }, 1200);
});


var heightChecker = setInterval(function () {

    var allLoaded = true;

    $('.match-new-category img').each(function () {
        if (!this.complete || this.naturalHeight === 0) {
            allLoaded = false;
        }
    });

    if (allLoaded) {
        $('.match-new-category').matchHeight('remove');
        $('.match-new-category').matchHeight();

        clearInterval(heightChecker);
        console.log('All images loaded. MatchHeight applied.');
    }

}, 500);

/* ========================================== End Of Match Height Javascript ========================================== */

jQuery(".toggle-btn").on("click", function() {
var $btn = $(this);
var $content = $btn.closest(".content-box").find(".more-text");

$content.slideToggle(800); // slide open/close

// Toggle button text
if ($btn.text() === "View More +") {
    $btn.text("View Less -");
} else {
    $btn.text("View More +");
}
});




// ==== Remove Spna Tag and add Space Between Text and Number  =========

jQuery(document).ready(function(){

    $(document).ready(() => {
    function removeSpans() {
        $('#gf-tree button[role="checkbox"]').each(function() {
        const $btn = $(this);
        
        // Remove ALL spans by class order - FIRST .gf-Checkbox, THEN others
        //$btn.children('.gf-Checkbox').remove();  // Kill empty checkbox span FIRST
        $btn.children('.gf-label, .gf-count').each(function() {
            const $span = $(this);
            $span.contents().appendTo($btn);  // Move text up
            $span.remove();        
        });

        // Insert space between text nodes
        $btn.contents().filter(function() {
            return this.nodeType === 3;
        }).each(function() {
            if (this.textContent.includes('(')) {
            this.textContent = ' ' + this.textContent;
            }
        });

        });
    }
    
    // removeSpans();
    const observer = new MutationObserver(removeSpans);
    observer.observe(document.body, { childList: true, subtree: true });
    });


    // $('.accordion-box:eq(1) .accordion-title, .accordion-box:last-child .accordion-title').on('click', function(e) {        
    //     // Scroll to top/header smoothly
    //     $('html, body').animate({
    //         scrollTop: 200  // Goes to page top (header)
    //     }, 500);  // 500ms smooth scroll
    // });

});

jQuery(document).ready(function(){

// $(document).on('click touchstart', '.accordion-box:eq(1) .accordion-title a, .accordion-box:last-child .accordion-title a', function(e) {
//     if ($(window).width() <= 956) {
//         // Mobile: Block default scroll + control position
//         e.preventDefault();
//         e.stopImmediatePropagation();
        
//         // Let theme accordion toggle first, THEN fix scroll
//         setTimeout(() => {
//             var $title = $(this);
//             var titleTop = $title.offset().top;
            
//             // Scroll so title stays visible (100px from top)
//             $('html, body').animate({
//                 scrollTop: titleTop - 150
//             }, 100);
//         }, 50); // Wait for accordion animation
        
//         return false;
//     }
    
//     // Desktop: Scroll to 50% height
//     var scrollPos = $(window).height() * 0.5;
//     $('html, body').animate({ 
//          scrollTop: 200
//     }, 500);
// });


$(document).on('click touchstart', '.product-info .accordion-box .accordion-title, .product-info .accordion-box .accordion-title', function(e) {
    if ($(window).width() > 956) {
        // Desktop: 50% scroll
        //var scrollPos = $(window).height() * 0.5;
        $('html, body').animate({ scrollTop: 200 }, 100);
        return;
    }
    
    // Mobile: Block ALL scroll + fix position after theme JS
    e.preventDefault();
    e.stopImmediatePropagation();
    
    var $title = $(this);
    var originalScroll = $(window).scrollTop(); // Remember position
    
    setTimeout(() => {
        // Force scroll back to title after accordion finishes (350ms)
        var titleTop = $title.offset().top;
        $('html, body').animate({
            scrollTop: titleTop - 150  // Title visible at top
        }, 0);
    }, 400); // Critical: Matches theme accordion speed
    
    return false;
});




});





// // Initialize on load AND resize
// $(window).ready(initAccordionScroll);
// $(window).resize(initAccordionScroll);


function setbg() {
  $(".img-mask").each(function() {
    var theBg = $(this).find(".bg-img").attr("src");
    $(this).css('background-image', 'url(' + theBg + ')');
    $(this).find("img.bg-img").hide();
  });
}
setbg();
